(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('klaviyo-ready-form')) return;
    var wrap = form.closest('[data-lsp-klaviyo-form]');
    if (!wrap) return;
    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput || !emailInput.value) return;

    window._learnq = window._learnq || [];
    window._learnq.push(['identify', {
      '$email': emailInput.value,
      'LifeSchool Free Lesson': wrap.getAttribute('data-pack-name') || '',
      'LifeSchool Free Lesson Tag': wrap.getAttribute('data-pack-tag') || ''
    }]);

    // When the Klaviyo list ID is available, replace REPLACE_WITH_KLAVIYO_LIST_ID in the form wrapper
    // or swap this block for the official Klaviyo onsite form embed/API submit.
  });
})();
